import CfSectionShell, { CfSectionShellFields } from '../cf-section-shell'
import { Stack } from '~/components-v2'
import { PostCollection } from '~/components-v2/post-collection/post-collection'
import { PostSummary } from '~/types/blog'
import type { Logo } from '../logostrip/CfLogoStripSection'
import { contentfulImage } from '~/utils/contentful-image'

export interface CardGridFields {
  headline?: string
  cardCollection: Card[]
  collectionType: 'post' | 'card'
  postCollection: PostSummary[]
}

interface Card {
  sys: {
    contentType: {
      sys: {
        id: 'post' | 'card'
      }
    }
  }
  logo: Logo
  description: string
  ctaUrl: string
  ctaLabel?: string
}

interface CfCardGridSectionProps {
  fields: CfSectionShellFields & CardGridFields
}

const CardCollection = ({ cards }: { cards: Card[] }) => {
  return (
    <div className="card-collection">
      {cards.map((card: Card, index: number) => {
        const { ctaUrl, ctaLabel, description, logo } = card
        const logoUrl = logo?.fields?.logo?.fields?.file?.url
        return (
          <div className="card" key={`card-${index}`}>
            <div className="card-logo-description-wrapper">
              {logoUrl && (
                <div className="card-logo">
                  <img
                    src={contentfulImage(logoUrl, { w: 400 })}
                    alt={logo?.fields?.name || 'Card logo'}
                  />
                </div>
              )}

              {description && (
                <div className="card-description">{description}</div>
              )}
            </div>

            {ctaUrl && (
              <a className="card-cta" href={ctaUrl}>
                {ctaLabel?.trim() || 'Read case study'} →
              </a>
            )}
          </div>
        )
      })}
    </div>
  )
}

export function CfCardGridSection({ fields }: CfCardGridSectionProps) {
  const { id, paddingTop, paddingBottom, showBottomBorder, theme } = fields
  const { headline, cardCollection, collectionType, postCollection } = fields

  return (
    <CfSectionShell
      id={id}
      paddingTop={paddingTop}
      paddingBottom={paddingBottom}
      showBottomBorder={showBottomBorder}
      theme={theme}
    >
      <div className="cf-card-grid">
        {headline && collectionType !== 'post' && (
          <Stack className="centered-section-title" as="hgroup">
            <h2 className="heading-xl">{headline}</h2>
          </Stack>
        )}

        {collectionType === 'card' && <CardCollection cards={cardCollection} />}

        {collectionType === 'post' && (
          <PostCollection
            header={
              headline ? (
                <Stack className="centered-section-title" as="hgroup">
                  <h2 className="heading-xl">{headline}</h2>
                </Stack>
              ) : undefined
            }
            posts={postCollection}
            variant="carousel"
          />
        )}
      </div>
    </CfSectionShell>
  )
}
